/**
 * Purty Body — mirror the selected Kaching bundle in the product ATC button.
 * Example: "Add 3 Pack - $66"
 */
(function () {
  'use strict';

  var SELECTED_DEAL = '.kaching-bundles__bar--selected';
  var DEAL_TITLE = '.kaching-bundles__bar-title';
  var DEAL_TOTAL = '.kaching-bundles__bar-price';
  var CART_LABEL = '.single-add-to-cart-button--text';
  var updateQueued = false;

  function getDirectText(element) {
    if (!element) return '';

    return Array.prototype.slice
      .call(element.childNodes)
      .filter(function (node) {
        return node.nodeType === Node.TEXT_NODE;
      })
      .map(function (node) {
        return node.textContent.trim();
      })
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tidyPrice(price) {
    return price
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\.00(?=\s*$)/, '');
  }

  function updateCartButtonLabel() {
    updateQueued = false;

    var selectedDeal = document.querySelector(SELECTED_DEAL);
    if (!selectedDeal) return;

    var bundleName = getDirectText(selectedDeal.querySelector(DEAL_TITLE));
    var bundleTotalElement = selectedDeal.querySelector(DEAL_TOTAL);
    var bundleTotal = bundleTotalElement
      ? tidyPrice(bundleTotalElement.textContent)
      : '';

    if (!bundleName || !bundleTotal) return;

    var newLabel = 'Add ' + bundleName + ' to cart - ' + bundleTotal;

    document.querySelectorAll(CART_LABEL).forEach(function (label) {
      var button = label.closest('button');

      /* Preserve genuine Sold out / Unavailable states from the theme. */
      if (button && button.disabled) return;

      if (label.textContent.trim() !== newLabel) {
        label.textContent = newLabel;
      }
    });
  }

  function queueUpdate() {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(updateCartButtonLabel);
  }

  function initialise() {
    queueUpdate();

    var observer = new MutationObserver(queueUpdate);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled']
    });

    document.addEventListener('change', queueUpdate, true);
    document.addEventListener('click', queueUpdate, true);

    /* Supports Shopify's live theme-editor section reloads. */
    document.addEventListener('shopify:section:load', queueUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
